const transformer = function (origin, defs, rowData, fields) {
  return {
    render: 'richText',
    origin,
    value: origin,
    onClick: origin.onClick,
    defs,
    rowData,
    fields,
    opts: defs,
  }
}

export default transformer
